import type { InstagramPreviewProfile } from '~publish/components/Composer/InstagramPreview/types'
import type { ComposerProfile } from '~publish/legacy/composer/composer/stores/types'

export function getProfilePreview(
  profile: ComposerProfile,
  displayName?: string,
): InstagramPreviewProfile {
  return {
    channelId: profile.id,
    name: profile.service?.name,
    username: profile.service?.username,
    formattedUsername: profile.service?.formattedUsername,
    avatar: profile.images?.avatar,
    displayName: displayName || profile.displayName,
    serverUrl: profile.serverUrl,
    serviceType: profile.serviceType,
    isTwitterPremium: profile.isTwitterPremium ?? false,
    timezone: profile.timezone,
  }
}
